export default __webpack_public_path__ + "static/media/DHTable1Img.e06dcd82.PNG";